import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import ContactUs from  '../views/ContactUs/index.vue'
import JoinUs from  '../views/JoinUs/index.vue'
import Products from  '../views/Products/index.vue'
import ProductsDetail from '../views/ProductsDetail/index.vue'
import Brand from '../views/Brand/index.vue'
import BrandCooperate from '../views/BrandCooperate/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contact_us',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/join_us',
    name: 'JoinUs',
    component: JoinUs
  },
  {
    path: '/brand_cooperate',
    name: 'BrandCooperate',
    component: BrandCooperate
  },
  {
    path: '/brand',
    name: 'Brand',
    component: Brand
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/products_detail',
    name: 'ProductsDetail',
    component: ProductsDetail
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
